<template>
  <div class="main-body">
    <div class="header">悦琦一体机</div>
    <div class="out">
      <div class="search2">

          <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">绑定</el-button>

        <div style="clear: both;"></div>
      </div>

      <div>
        <template>
          <el-table class="table" size="mini" v-loading="tableLoading"
                    :data="tableData" :height="th" border>

            <el-table-column prop="name" label="设备名称"></el-table-column>

            <el-table-column prop="equipmentID" label="设备号"></el-table-column>

            <el-table-column prop="bindTime" label="绑定时间" :formatter="timefilter"></el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="success" size="mini" @click="deviceInfo(scope.row)">数据查看</el-button>
                <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
              </template>
            </el-table-column>

          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage" @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>
    <DeviceInfo ref="myDeviceInfo" v-show="showModalDeviceInfo"
                v-on:closeDeviceInfo="showModalDeviceInfo=false"
                v-on:getList="getList"></DeviceInfo>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode,getGovernmentCode } from "@/utils/auth";

import Add from "./Add"
import DeviceInfo from "./DeviceInfo"

export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalDeviceInfo:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      name:'',
      phone: "",
      sn: "",

    };
  },
  components: {
    Add,DeviceInfo
  },
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
        this.$refs.myAdd.init();
        this.showModalAdd = !this.showModalAdd;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "YqMachine/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          _this.tableLoading=false
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          _this.tableLoading=false
          console.log(error);
        });
    },

    deviceInfo(row){
      this.$refs.myDeviceInfo.init(row);
      this.showModalDeviceInfo = !this.showModalDeviceInfo;
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {

      this.$confirm("您确定要解绑该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {

          this.$axios({
            method: "post",
            url: this.$deviceUrl + "YqMachine/Unbundling",
            data: {
              timeStr: timeStr,
              sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
              yqMachineCode: row.yqMachineCode,
            },
          }).then((response) => {
              if (response.data.error == 0) {
                this.$message({message: "解绑成功", type: "success",});
                this.getList();
              } else if (response.data.error == 1) {
                this.$message.error(response.data.message);
              }
          }).catch(function (error) {
            console.log(error);
          });


      }).catch(() => {
        this.$message({type: "info", message: "已取消解绑",});
      });

    },

  },
};
</script>

<style scoped>
</style>
